<template>
    <div class="bg-white">
        <Hero :title="model.title" :lead="$t('about_us.lead')" />

        {{/* Content */}}
        <div class="text-black pb-16 md:pb-28 xl:pb-36">
            <div class="container">
                <div class="grid grid-cols-12 lg gap-5">
                    <div class="col-span-12 lg:col-span-8 lg:col-start-3">
                        <div class="tinymce-content" v-html="model.body"></div>
                        <SectionDownloadables v-if="model.downloads" :attachments="model.downloads" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Hero from '@/components/Heroes/Hero';
import SectionDownloadables from '@/components/Sections/SectionDownloadables/SectionDownloadables';

export default {
    name: 'AboutUs',
    components: {
        Hero,
        SectionDownloadables,
    },
    async asyncData({ $axios, error, i18n }) {
        let model = null;

        await $axios
            .$get('/content/by-slug/about-us')
            .then((res) => {
                if (res.success === 1) {
                    model = res.data;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return error({ statusCode: 404, message: i18n.t('error.page_not_found.title') });
        }

        return { model };
    },
    head() {
        return {
            title: this.$t('about_us.title'),
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.$getOgTitle(this.$t('about_us.title')),
                },
                {
                    hid: 'title',
                    name: 'title',
                    content: this.$getOgTitle(this.$t('about_us.title')),
                },
            ],
        };
    },
};
</script>

<style scoped></style>
